import React from 'react';
import { Box, Typography } from '@mui/material';

const NoCodePartRow = ({ part, localImage = false }) => {
  const getImagePath = (imageName) => {
    if (!imageName) return null;
    return localImage
      ? `${process.env.PUBLIC_URL}/${imageName}`
      : `https://s3.us-east-2.amazonaws.com/366images/${imageName}`;
  };

  return (
    <Box 
      sx={{
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#24e4ff',
        borderRadius: '15px',
        padding: '15px',
        marginBottom: '20px',
        cursor: 'pointer',
        '&:hover': {
          opacity: 0.9
        }
      }}
    >
      {/* Header with part number and price */}
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'space-between',
          marginBottom: '10px'
        }}
      >
        <Typography 
          sx={{ 
            color: '#000',
            fontSize: '18px',
            fontWeight: 'bold'
          }}
        >
          {part.partNumber}
        </Typography>
        <Typography 
          sx={{ 
            color: '#000',
            fontSize: '18px',
            fontWeight: 'bold'
          }}
        >
          ${part.price}
        </Typography>
      </Box>

      {/* Image Container */}
      <Box 
        sx={{ 
          backgroundColor: '#fff',
          borderRadius: '10px',
          padding: '10px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '150px'
        }}
      >
        {part.image1 && (
          <img 
            src={getImagePath(part.image1)}
            alt={part.partNumber}
            style={{
              maxWidth: '100%',
              maxHeight: '200px',
              objectFit: 'contain'
            }}
          />
        )}
      </Box>
    </Box>
  );
};

export default NoCodePartRow; 